import { ComplextRoute } from 'router/components/Routes/Routes';
import { MarketYourListing } from './pages/MarketYourListing';
import EditDealRoom from './pages/EditDealRoom';
import UploadImSuccessfulyWrapper from './pages/UploadImSuccessfulyWrapper';

export default [
  {
    index: true,
    element: EditDealRoom,
  },
  {
    path: 'market-listing',
    element: MarketYourListing,
  },
  {
    path: 'im-upload-successful',
    element: UploadImSuccessfulyWrapper,
  },
] as Array<ComplextRoute>;
